import PropTypes from 'prop-types';
import { Wrap } from '../../../styled';
import { Img, Date, Author, Container } from './styled';

const Post = (props) => {
  const { date, title, author, content, image } = props;

  return (
    <Container>
      <Wrap>
        <h1>{title}</h1>
        <Date>{date}</Date>
        <Author>{author}</Author>
        <Img src={image} alt={title} />
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </Wrap>
    </Container>
  );
};

Post.propTypes = {
  date: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
  content: PropTypes.node.isRequired,
  image: PropTypes.string.isRequired,
};

export default Post;
